<template>
  <div class="content-body">
    <section class="flexbox-container">
      <div class="col-12 d-flex align-items-center justify-content-center">
        <div class="col-md-4 col-10 box-shadow-2 p-0">
          <div class="card border-grey border-lighten-3 px-1 py-1 m-0">
            <div class="border-0">
              <div class="text-center mb-1">
                <img src="images/logo/logo.png" alt="branding logo" class="login-logo">
                <br />
                <div class="text-right">
                  <small>Version 0.5.1</small>
                </div>
              </div>
            </div>
            <div class="card-content">
              <div class="card-body">
                <form class="form-horizontal" id="login-form" v-on:submit.prevent="login">
                  <fieldset class="form-group position-relative has-icon-left">
                    <input type="text" class="form-control" id="email" placeholder="Username" required v-model="email">
                    <div class="form-control-position">
                      <i class="ft-user"></i>
                    </div>
                  </fieldset>
                  <fieldset class="form-group position-relative has-icon-left">
                    <input type="password" class="form-control" id="password" placeholder="Enter Password" required v-model="password">
                    <div class="form-control-position">
                      <i class="ft-lock"></i>
                    </div>
                  </fieldset>

                  <div class="alert alert-danger mb-2" role="alert" v-if="errorMsg">
                    <strong>Oh snap!</strong> {{errorMsg}}
                  </div>

                  <div class="form-group text-center">
                    <button type="submit" class="btn btn-block btn-glow btn-primary">Login</button>
                  </div>
                  <div class="form-group text-center">
                    <button type="submit" class="btn btn-block btn-glow btn-secondary" v-on:click="cameraLogin"><i class="ft-camera"></i> Login With Camera</button>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-12 col-12 text-center"><a href="https://admin.goldenspoon.co.za/login/forgot_password" class="card-link" target="_blank">Forgot Password?</a></div>
                  </div>

                  <p class="card-subtitle text-muted my-1"><span>Don't have an account ? <router-link to="/verify" class="card-link">Sign Up</router-link></span></p>

                </form>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'login',
  data: function () {
    return {
      email: '',
      password: '',
      errorMsg: ''
    }
  },
  methods: {
    cameraLogin: function () {
      var that = this
      that.errorMsg = ''

      // eslint-disable-next-line
      cordova.plugins.barcodeScanner.scan(
        function (result) {
          var data = {
            device_identifier: result.text
          }

          $.ajax({
            beforeSend: function (xhr) {
              $.showLoading()
              if (window.localStorage.getItem('token')) {
                xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
              }
            },
            complete: function () {
              $.hideLoading()
            },
            url: that.$config.apiUrl + 'basic/goldenspoon_login',
            type: 'post',
            data: JSON.stringify(data),
            success: function (data) {
              console.log('SUCCESS DATA')
              console.log(data)

              if (typeof data.success !== 'undefined' && data.success === true) {
                window.localStorage.setItem('user', JSON.stringify(data.data))
                window.localStorage.setItem('token', data.meta.token)
                if (data.data.merchant) {
                  that.$router.push('/merchant')
                } else {
                  that.$router.push('/')
                }
              } else {
                var meta = JSON.parse(data.responseText)
                that.showError(meta.meta.reason)
              }
            },
            error: function (data) {
              var meta = JSON.parse(data.responseText)
              that.showError(meta.meta.reason)
            }
          })
        },
        function (error) {
          alert('Scanning failed: ' + error)
        }, {
          preferFrontCamera: true,
          showFlipCameraButton: true
        }
      )
    },
    login: function () {
      var that = this
      that.errorMsg = ''

      var data = {
        email: this.email,
        password: this.password,
        deviceId: window.localStorage.getItem('deviceId')
      }

      $.ajax({
        beforeSend: function (xhr) {
          $.showLoading()
          if (window.localStorage.getItem('token')) {
            xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
          }
        },
        complete: function () {
          $.hideLoading()
        },
        url: this.$config.apiUrl + 'basic/login',
        type: 'post',
        data: JSON.stringify(data),
        success: function (data) {
          if (typeof data.success !== 'undefined' && data.success === true) {
            window.localStorage.setItem('user', JSON.stringify(data.data))
            window.localStorage.setItem('token', data.meta.token)
            if (data.data.merchant) {
              that.$router.push('/merchant')
            } else {
              that.$router.push('/')
            }
          } else {
            var meta = JSON.parse(data.responseText)
            that.showError(meta.meta.reason)
          }
        },
        error: function (data) {
          var meta = JSON.parse(data.responseText)
          that.showError(meta.meta.reason)
        }
      })
    },
    showError: function (message) {
      this.errorMsg = message
    }
  }
}
</script>

<style scoped>
.login-logo {
  width:100%;
}
</style>
